/* eslint-disable no-unused-vars */

import store from '../store'
import router from "@/router";
import PaymentService from "@/services/payment";

const tabsForReadyUsersOnly = [
  'pedidos',
  'solicitar-saque',
  'extrato'
]

const pagesForReadyUsersOnly = [
  'new-bike'
]


class Permission {

  constructor(user) {
    this.user = user ? user : store.state.auth.user.user;
    this.token = store.state.auth.user.token;
  }

  userIsReady() {

     let isPJ;

     if (this.user.typeRegistration) {
        isPJ = this.user.typeRegistration === 'pj' || false
     }

     if (this.user.additionalInformation) {
        isPJ = this.user.additionalInformation.type === 'pj' || false
     }

     const pf = () => {
        return !!(this.user.additionalInformation.phone &&
           this.user.additionalInformation.cpf &&
           this.user.additionalInformation.gender &&
           this.user.address.cep &&
           this.user.address.street &&
           this.user.address.number &&
           this.user.address.district &&
           this.user.address.state &&
           this.user.address.city &&
           this.user.firstName &&
           this.user.lastName
        )
     }

     const pj = () => {
        return !!(this.user.additionalInformation.phone &&
           this.user.additionalInformation.cpf &&
           this.user.address.cep &&
           this.user.address.street &&
           this.user.address.number &&
           this.user.address.district &&
           this.user.address.state &&
           this.user.address.city &&
           this.user.firstName &&
           this.user.lastName &&
           this.user.additionalInformation.businessName &&
           this.user.additionalInformation.corporateName
        )
     }

   return isPJ ? pj() : pf()
  }

  userHasBankAccount() {
    return this.user.bankAccount.length > 0
  }

  userHasDigitalAccount() {
    return !!(this.user.digitalAccount)
  }

  async userHasDocs() {
    return await PaymentService.ListDocuments()
  }

  approvedDigitalAccount() {
     if (this.user.digitalAccount) {
        return (this.user.digitalAccount.status === 'VERIFIED' || this.user.digitalAccount.status === "AWAITING_DOCUMENTS" || this.user.digitalAccount.status === "VERIFYING")
     }
  }

  readyUsersOnly() {

      if ( pagesForReadyUsersOnly.includes(router.currentRoute.name) ||
        tabsForReadyUsersOnly.includes( router.currentRoute.params.page )
      ) {
        if ( this.userIsReady() ) {
           return true
        }
      }
      return false

  }

  thePhoneIsVerified() {
     return this.user.additionalInformation.verifiedPhone
  }

}

export default Permission;
